import { getCookie } from 'cookies-next';

import { parseJwt } from '@/app/_helper/base64';

import { SeenListingHooksReturn } from '../_type/seenListingType';

const useSeenListing = (): SeenListingHooksReturn => {
    const token = getCookie('rw-id')?.toString() || '';

    const parseToken = parseJwt(token);
    const userId = parseToken?.userId ? `${parseToken?.userId}` : '';

    const postSeenListing = async (originIds: string[]) => {
        fetch(`${process.env.NEXT_PUBLIC_COREWEB_API_URL}/seen-listing/seen`, {
            method: 'POST',
            headers: {
                'Accept-Language': 'id',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                originIds,
                type: 'VISITED',
                uniqueId: userId && userId.length > 0 ? userId : undefined,
            }),
        });
    };

    return { postSeenListing };
};

export default useSeenListing;
